import React from 'react';
import './Friendyconfiger.css';
import remoteImg from '../../../imgs/friendly.webp';  
import airblowImg from '../../../imgs/configurat.webp';

const Friendyconfiger = () => {
  return (
    <div className="friendly-container">
      <div className="friendly-column">
        <h2>FRIENDLY CONTROL SYSTEM</h2>
        <ul>
          <li>Internet remote control.</li>
          <li>Multiple language options,</li>
          <li>Multiple user levels.</li>
          <li>Ether CAT interface.</li>
          <li>New Ether-77 interface (optional).</li>
        </ul>
        <img src={remoteImg} alt="Remote Control" className="friendly-img" />
      </div>

      <div className="friendly-column">
        <h2>OTHER CONFIGURATIONS</h2>
        <p>
          The standard configuration of multi-sets of air blowing is designed specially for fast cycle production.
        </p>
        <img src={airblowImg} alt="Air Blowing System" className="friendly-img" />
      </div>
    </div>
  );
};

export default Friendyconfiger;
